import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QaLocatorsModule } from '@metromarkets/sdk';
import { KebabCaseModule } from '~shared/pipes';
import { TranslateModule } from '@ngx-translate/core';
import { MmFlexLayoutModule } from '@metromarkets/components';
import { ProductPromotionComponent } from '~shared/modules/product-promotion/product-promotion.component';

@NgModule({
  declarations: [
    ProductPromotionComponent
  ],
  imports: [
    CommonModule,
    MmFlexLayoutModule,
    QaLocatorsModule,
    KebabCaseModule,
    TranslateModule,
  ],
  exports: [
    ProductPromotionComponent,
  ]
})
export class ProductPromotionModule {
}
